const ENRICH_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/enrich-contact`;

async function getToken(): Promise<string | undefined> {
  const { getTokenSilently } = await import("@/utils/auth");
  return getTokenSilently();
}

export interface PersonEnrichment {
  firstName?: string;
  lastName?: string;
  title?: string;
  company?: string;
  phone?: string;
  location?: string;
  linkedin?: string;
}

export interface CompanyEnrichment {
  name?: string;
  industry?: string;
  employees?: string;
  revenue?: string;
  location?: string;
  phone?: string;
  linkedin?: string;
  description?: string;
}

export async function enrichPerson(email: string): Promise<PersonEnrichment | null> {
  try {
    const token = await getToken();
    if (!token) return null;

    const resp = await fetch(ENRICH_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      },
      body: JSON.stringify({ type: "person", email }),
    });
    if (!resp.ok) return null;
    const json = await resp.json();
    return json.success ? json.data : null;
  } catch {
    return null;
  }
}

export async function enrichCompany(website: string, name?: string): Promise<CompanyEnrichment | null> {
  try {
    const token = await getToken();
    if (!token) return null;

    const resp = await fetch(ENRICH_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      },
      body: JSON.stringify({ type: "company", website, name }),
    });
    if (!resp.ok) return null;
    const json = await resp.json();
    return json.success ? json.data : null;
  } catch {
    return null;
  }
}
